import { useLocation, useNavigate } from "react-router-dom";
import { setNavigator } from "./utils/navigationService";
import { useEffect, useState } from "react";
import UIProviders from "./context/UIProviders";
import AppRoutes from "./routes/appRoutes";
import MainLayout from "./layouts/MainLayout";
import "./App.scss";
import { ROUTES } from "./routes/routePaths";

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setNavigator(navigate);
  }, [navigate]);

  useEffect(() => {
    const navType = window.performance.getEntriesByType("navigation")[0]?.type;
    if (navType === "back_forward" && location.pathname !== ROUTES.HOME) {
      window.location.href = ROUTES.HOME;
    }
  }, [location.pathname]);

  return (
    <UIProviders>
      <MainLayout>
        <AppRoutes />
      </MainLayout>
    </UIProviders>
  );
}

export default App;
